import {apiSlice} from './apiSlice';

/**
 * Endpoints quản trị kết nối Google Ads / Keyword Planner (admin, cap member_manage).
 *
 * MỘT tài khoản Google Ads cấp hệ thống (nguồn volume/CPC từ khoá cho mọi user):
 * getAdsStatus → getAdsAuthUrl (state 'ads.<nonce>') → redirect Google → callback dùng
 * chung /gsc/oauth/callback POST connectAds → setAdsCustomer (customer_id +
 * login_customer_id). Tag 'AdsSettings' invalidate sau mọi mutation cấu hình.
 */
export const adsApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getAdsStatus: builder.query({
			query: () => ({url: 'admin/google-ads', method: 'get'}),
			transformResponse: (body) => body?.data || null,
			providesTags: [{type: 'AdsSettings', id: 'status'}],
		}),
		getAdsAuthUrl: builder.mutation({
			query: () => ({url: 'admin/google-ads/auth-url', method: 'get'}),
			transformResponse: (body) => body?.data || null,
		}),
		connectAds: builder.mutation({
			query: ({code, state}) => ({url: 'admin/google-ads/connect', method: 'post', data: {code, state}}),
			transformResponse: (body) => body?.data || null,
			invalidatesTags: [{type: 'AdsSettings', id: 'status'}],
		}),
		getAdsCustomers: builder.query({
			query: () => ({url: 'admin/google-ads/customers', method: 'get'}),
			transformResponse: (body) => body?.data?.customers || [],
		}),
		setAdsCustomer: builder.mutation({
			query: ({customer_id, login_customer_id}) => ({
				url: 'admin/google-ads/customer',
				method: 'put',
				data: {customer_id, login_customer_id},
			}),
			transformResponse: (body) => body?.data || null,
			invalidatesTags: [{type: 'AdsSettings', id: 'status'}],
		}),
		setAdsBudget: builder.mutation({
			query: ({daily_budget}) => ({
				url: 'admin/google-ads/budget',
				method: 'put',
				data: {daily_budget},
			}),
			transformResponse: (body) => body?.data || null,
			invalidatesTags: [{type: 'AdsSettings', id: 'status'}],
		}),
		disconnectAds: builder.mutation({
			query: () => ({url: 'admin/google-ads', method: 'delete'}),
			invalidatesTags: [{type: 'AdsSettings', id: 'status'}],
		}),
	}),
});

export const {
	useGetAdsStatusQuery,
	useGetAdsAuthUrlMutation,
	useConnectAdsMutation,
	useGetAdsCustomersQuery,
	useSetAdsCustomerMutation,
	useSetAdsBudgetMutation,
	useDisconnectAdsMutation,
} = adsApiSlice;
